/*
 * @Author: zhuqiu
 * @Date: 2020-05-19 13:53:54
 * @LastEditTime: 2022-02-17 19:06:01
 * @LastEditors: Fu Zhuohang
 * @Description: In User Settings Edit
 * @FilePath: \yunshu6.0-3\modules\@cloudpivot\form\src\components\Create\conduct.ts
 */
import baseAttribute from "../../common/component-base-attribute";
import { ControlAttributeType } from "../../../typings";
import { formatterValueToSetStatus } from "../../../utils";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: "创建人" }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: "人员单选" }),
        mappings: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../common/components/user-selection-map2.vue"),
            options: {},
            formatter: formatterValueToSetStatus,
        },
    },
};
